(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["balnia-qtyselector"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    function makeMoney(fmt) {
      return function (cents) {
        var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
        var name = m ? m[1] : 'amount';
        var value;
        switch (name) {
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
          case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
          case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
          case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
          default: value = formatWithDelimiters(cents, 2);
        }
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
      };
    }
    function debounce(fn, ms) {
      var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
    }
    function productForms(root) {
      var out = [], forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (!forms[i].closest('[data-bqs-root]')) out.push(forms[i]);
      }
      return out;
    }

    function initRoot(root) {
      if (root.dataset.bqsReady) return;
      root.dataset.bqsReady = '1';

      // Repli sans accolades litterales : ce bloc JS doit rester 100 % statique.
      var defFmt = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
      var money = makeMoney(root.getAttribute('data-money-format') || defFmt);
      var perSuffix = root.getAttribute('data-per-suffix') || '';
      var discType = root.getAttribute('data-disc-type');
      var cmpType = root.getAttribute('data-cmp-type');
      var showCompare = root.getAttribute('data-show-compare') === 'true';
      var showPer = root.getAttribute('data-show-per') === 'true';
      var doSync = root.getAttribute('data-sync') === 'true';
      var perUnit = root.getAttribute('data-per-unit') === 'true';
      var doAjax = root.getAttribute('data-ajax') === 'true';
      var after = root.getAttribute('data-after');
      var addedTxt = root.getAttribute('data-added') || 'Ajoute';
      var paintPrice = root.getAttribute('data-atc-price') === 'true';
      var addUrl = root.getAttribute('data-add-url');
      var cartUrl = root.getAttribute('data-cart-url');
      var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
      var compare = parseInt(root.getAttribute('data-compare'), 10) || unit;
      var defaultId = root.getAttribute('data-default-id') || '';
      var map = {};
      try { map = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) {}

      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-bqs-opt]'));
      var swatches = Array.prototype.slice.call(root.querySelectorAll('.bp__val'));
      var chosenQty = 1;

      function cardOf(el) { return el ? el.closest('[data-bqs-card]') : null; }
      function activeCard() { return root.querySelector('[data-bqs-card].is-active'); }

      function currentId() {
        var forms = productForms(root);
        for (var i = 0; i < forms.length; i++) {
          var el = forms[i].querySelector('[name="id"]');
          if (el && el.value) return el.value;
        }
        return defaultId;
      }

      /* ---------- choix des variantes ---------- */
      function readSelection() {
        var sel = {};
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].classList.contains('is-sel')) {
            sel[swatches[i].getAttribute('data-pos')] = swatches[i].getAttribute('data-val');
          }
        }
        return sel;
      }
      function matchVariant(sel) {
        for (var id in map) {
          var v = map[id];
          if (sel['1'] && v.o1 !== sel['1']) continue;
          if (sel['2'] && v.o2 !== sel['2']) continue;
          if (sel['3'] && v.o3 !== sel['3']) continue;
          return id;
        }
        return null;
      }
      function availWith(sel, pos, val) {
        for (var id in map) {
          var v = map[id];
          if (v['o' + pos] !== val) continue;
          var ok = true;
          for (var p in sel) {
            if (p !== pos && sel[p] && v['o' + p] !== sel[p]) { ok = false; break; }
          }
          if (ok && v.a) return true;
        }
        return false;
      }
      // Repercute le choix sur TOUS les selecteurs de variante de la page
      // (celui du bloc Achat par exemple), pour qu'ils restent d'accord.
      function mirror(pos, val) {
        var all = document.querySelectorAll('.bp__val[data-pos="' + pos + '"]');
        for (var i = 0; i < all.length; i++) {
          all[i].classList.toggle('is-sel', all[i].getAttribute('data-val') === val);
        }
        var labels = document.querySelectorAll('[data-bp-optsel="' + pos + '"]');
        for (var j = 0; j < labels.length; j++) labels[j].textContent = val;
      }
      function applyVariant() {
        if (!swatches.length) return;
        var sel = readSelection();
        for (var i = 0; i < swatches.length; i++) {
          var s = swatches[i];
          s.classList.toggle('is-out', !availWith(sel, s.getAttribute('data-pos'), s.getAttribute('data-val')));
        }
        var id = matchVariant(sel);
        if (!id) return;
        unit = map[id].p; compare = map[id].c;
        var forms = productForms(root);
        for (var f = 0; f < forms.length; f++) {
          var el = forms[f].querySelector('[name="id"]');
          if (el && el.value !== String(id)) {
            el.value = id;
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        recalc();
      }
      if (swatches.length) {
        root.addEventListener('click', function (e) {
          var btn = e.target && e.target.closest ? e.target.closest('.bp__val') : null;
          if (!btn || btn.classList.contains('is-out')) return;
          mirror(btn.getAttribute('data-pos'), btn.getAttribute('data-val'));
          applyVariant();
        });
      }

      // Ecrit la quantite choisie dans le formulaire produit de la page.
      // Aucun ajout au panier ici : c'est ton propre bouton qui s'en charge.
      function pushQty() {
        if (!doSync) return;
        var forms = productForms(root);
        for (var i = 0; i < forms.length; i++) {
          var qi = forms[i].querySelector('[name="quantity"]');
          if (!qi) continue;
          if (parseInt(qi.value, 10) === chosenQty) continue;
          qi.value = chosenQty;
          qi.dispatchEvent(new Event('input', { bubbles: true }));
          qi.dispatchEvent(new Event('change', { bubbles: true }));
        }
        document.dispatchEvent(new CustomEvent('balnia:quantity', { detail: { quantity: chosenQty } }));
      }

      function recalc() {
        for (var k = 0; k < opts.length; k++) {
          var el = opts[k];
          var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
          var pct = parseFloat(el.getAttribute('data-pct')) || 0;
          var fixed = parseInt(el.getAttribute('data-fixed'), 10) || 0;
          var off = discType === 'fixed' ? fixed : Math.round(unit * pct / 100);
          var after = unit - off; if (after < 0) after = 0;
          var total = after * qty;
          var cmpUnit = (cmpType === 'original' && compare > unit) ? compare : unit;
          var cmpTotal = cmpUnit * qty;
          var savings = cmpTotal - total; if (savings < 0) savings = 0;
          var pctnum = cmpTotal > 0 ? Math.round(savings * 100 / cmpTotal) : 0;

          var totalEl = el.querySelector('[data-bqs-total]');
          if (totalEl) totalEl.innerHTML = money(total);
          var cmpEl = el.querySelector('[data-bqs-compare]');
          if (cmpEl) {
            if (showCompare && savings > 0) { cmpEl.innerHTML = money(cmpTotal); cmpEl.removeAttribute('hidden'); }
            else { cmpEl.setAttribute('hidden', ''); }
          }
          var perEl = el.querySelector('[data-bqs-per]');
          if (perEl && showPer) perEl.innerHTML = money(after) + ' ' + perSuffix;
          var saveEl = el.querySelector('[data-bqs-save]');
          if (saveEl) {
            var tpl = saveEl.getAttribute('data-tpl') || '';
            saveEl.innerHTML = tpl.replace('[%]', pctnum + '%').replace('[$]', money(savings));
          }
        }
      }

      function syncVariant() {
        var id = currentId();
        if (id && map[id]) { unit = map[id].p; compare = map[id].c; }
        recalc();
      }

      function select(el) {
        for (var k = 0; k < opts.length; k++) {
          var c = cardOf(opts[k]);
          if (c) c.classList.remove('is-active');
          opts[k].setAttribute('aria-pressed', 'false');
        }
        var mine = cardOf(el);
        if (mine) mine.classList.add('is-active');
        el.setAttribute('aria-pressed', 'true');
        chosenQty = parseInt(el.getAttribute('data-qty'), 10) || 1;
        pushQty();
        pushFirstUnit();
        paintAtc();
      }

      for (var k = 0; k < opts.length; k++) {
        (function (el) { el.addEventListener('click', function () { select(el); }); })(opts[k]);
      }

      /* ---------- une taille par piece ---------- */
      // Les pastilles de piece n'utilisent pas la classe .bp__val exprès : elles
      // ne doivent pas etre confondues avec le selecteur de variante global.
      root.addEventListener('click', function (e) {
        var u = e.target && e.target.closest ? e.target.closest('[data-bqs-uval]') : null;
        if (!u || u.disabled || u.classList.contains('is-out')) return;
        var grp = u.parentNode.querySelectorAll('[data-bqs-uval]');
        for (var i = 0; i < grp.length; i++) grp[i].classList.remove('is-sel');
        u.classList.add('is-sel');
        pushFirstUnit();
        paintAtc();
      });
      root.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('[data-bqs-unit]')) {
          pushFirstUnit();
          paintAtc();
        }
      });

      // Ce que chaque piece du pack actif a choisi, dans l'ordre.
      function unitPicks() {
        var card = activeCard(), out = [];
        if (!card) return out;
        var rows = card.querySelectorAll('.bqs__unit');
        for (var i = 0; i < rows.length; i++) {
          var sel = rows[i].querySelector('select[data-bqs-unit]');
          if (sel && sel.value) { out.push(sel.value); continue; }
          var on = rows[i].querySelector('[data-bqs-uval].is-sel');
          if (on) out.push(on.getAttribute('data-vid'));
        }
        return out;
      }

      // Le formulaire produit ne transporte qu'un seul identifiant de variante :
      // on y met celle de la premiere piece, pour que tout reste coherent si
      // l'ajout se fait finalement par la voie native.
      function pushFirstUnit() {
        if (!perUnit) return;
        var picks = unitPicks();
        if (!picks.length) return;
        var forms = productForms(root);
        for (var f = 0; f < forms.length; f++) {
          var el = forms[f].querySelector('[name="id"]');
          if (el && el.value !== String(picks[0])) {
            el.value = picks[0];
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (map[picks[0]]) { unit = map[picks[0]].p; compare = map[picks[0]].c; recalc(); }
      }

      // Le bouton d'ajout affiche le prix du pack, pas celui d'une seule piece.
      function paintAtc() {
        if (!paintPrice) return;
        var card = activeCard(); if (!card) return;
        var tot = card.querySelector('[data-bqs-total]'); if (!tot) return;
        var btns = document.querySelectorAll('[data-bp-atc]');
        for (var i = 0; i < btns.length; i++) {
          if (btns[i].disabled) continue;
          btns[i].setAttribute('data-atc-price', 'false');
          var lbl = btns[i].querySelector('[data-bp-atc-label]');
          if (!lbl) continue;
          var base = btns[i].getAttribute('data-atc-text') || lbl.textContent;
          lbl.textContent = base + ' · ' + tot.textContent;
        }
      }

      /* ---------- ajout au panier ---------- */
      // Plusieurs tailles dans un meme pack, c'est plusieurs lignes de panier :
      // le formulaire produit ne sait pas faire, on passe par l'API panier.
      // Un identifiant de variante valable : un entier positif present dans le
      // catalogue de la page. Tout le reste est ecarte, c'est ce qui provoquait
      // la page d'erreur « Nous n'avons pas trouve de variantes ».
      function cleanId(v) {
        var n = parseInt(v, 10);
        if (!n || n < 1) return 0;
        return map[String(n)] ? n : 0;
      }

      function buildItems() {
        var by = {}, out = [], picks = perUnit ? unitPicks() : [];
        for (var i = 0; i < picks.length; i++) {
          var pid = cleanId(picks[i]);
          if (pid) by[pid] = (by[pid] || 0) + 1;
        }
        for (var id in by) out.push({ id: parseInt(id, 10), quantity: by[id] });
        if (!out.length) {
          var one = cleanId(currentId()) || cleanId(defaultId);
          if (one) out.push({ id: one, quantity: chosenQty });
        }
        return out;
      }

      var errEl = root.querySelector('[data-bqs-err]');
      function showErr(msg) {
        if (!errEl) { if (msg) console.error('[balnia quantite]', msg); return; }
        if (msg) { errEl.textContent = msg; errEl.hidden = false; }
        else { errEl.textContent = ''; errEl.hidden = true; }
      }

      function onSubmit(e) {
        if (!doAjax) return;
        var form = e.currentTarget;
        // On coupe toujours la soumission classique : le formulaire produit ne
        // sait transporter qu'une variante, il enverrait un panier faux.
        e.preventDefault();
        e.stopPropagation();
        showErr('');

        var items = buildItems();
        if (!items.length) {
          showErr('Choisis une taille avant d\'ajouter au panier.');
          return;
        }
        var btn = form.querySelector('[data-bp-atc]') || form.querySelector('[type="submit"]');
        var lbl = btn ? btn.querySelector('[data-bp-atc-label]') : null;
        var old = lbl ? lbl.textContent : '';
        if (btn) btn.disabled = true;
        if (lbl) lbl.textContent = '...';
        function restore() {
          if (btn) btn.disabled = false;
          if (lbl) lbl.textContent = old;
        }
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (data) {
              if (!r.ok) {
                // Shopify renvoie le motif exact : rupture, quantite max, etc.
                var msg = data.description || data.message || ('Ajout refusé (' + r.status + ')');
                throw new Error(msg);
              }
              return data;
            });
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:change'));
            if (after === 'cart') { window.location.href = cartUrl; return; }
            restore();
            if (lbl) { lbl.textContent = addedTxt; setTimeout(function () { lbl.textContent = old; paintAtc(); }, 1600); }
            if (after === 'drawer' && typeof window.openCartDrawer === 'function') window.openCartDrawer();
          })
          .catch(function (err) {
            // On reste sur la page et on dit pourquoi, plutot que de renvoyer
            // vers la page d'erreur Shopify sans explication.
            restore();
            showErr((err && err.message) || 'Ajout au panier impossible.');
            console.error('[balnia quantite] envoi', items, err);
          });
      }
      function bindForms() {
        var forms = productForms(root);
        for (var i = 0; i < forms.length; i++) {
          if (forms[i].dataset.bqsBound) continue;
          forms[i].dataset.bqsBound = '1';
          forms[i].addEventListener('submit', onSubmit, true);
        }
      }
      bindForms();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindForms);
      window.addEventListener('load', bindForms);

      var pre = root.querySelector('[data-bqs-opt][aria-pressed="true"]') || opts[0];
      if (pre) select(pre);

      // La variante peut changer via les pastilles de la section produit
      // (qui ecrivent la propriete value, pas l'attribut) : on relit apres coup.
      var deb = debounce(syncVariant, 90);
      document.addEventListener('click', deb, true);
      document.addEventListener('change', deb, true);

      // Si un autre bloc modifie la quantite, on garde l'option cochee en phase.
      document.addEventListener('input', function (e) {
        var t = e.target;
        if (!t || t.name !== 'quantity' || t.closest('[data-bqs-root]')) return;
        var v = parseInt(t.value, 10) || 1;
        if (v === chosenQty) return;
        for (var i = 0; i < opts.length; i++) {
          if ((parseInt(opts[i].getAttribute('data-qty'), 10) || 1) === v) {
            for (var j = 0; j < opts.length; j++) {
              var cj = cardOf(opts[j]);
              if (cj) cj.classList.remove('is-active');
              opts[j].setAttribute('aria-pressed', 'false');
            }
            var ci = cardOf(opts[i]);
            if (ci) ci.classList.add('is-active');
            opts[i].setAttribute('aria-pressed', 'true');
            chosenQty = v;
            paintAtc();
            return;
          }
        }
      });

      applyVariant();
      syncVariant();
      paintAtc();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-bqs-root]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["balnia-quantity-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    function makeMoney(fmt) {
      return function (cents) {
        var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
        var name = m ? m[1] : 'amount';
        var value;
        switch (name) {
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
          case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
          case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
          case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
          default: value = formatWithDelimiters(cents, 2);
        }
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
      };
    }
    function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

    function initRoot(root) {
      if (root.dataset.bqbReady) return;
      root.dataset.bqbReady = '1';

      // Repli du format monétaire sans accolades litterales (JS 100% statique).
      var defFmt = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
      var money = makeMoney(root.getAttribute('data-money-format') || defFmt);
      var perSuffix = root.getAttribute('data-per-suffix') || '';
      var discType = root.getAttribute('data-disc-type');
      var cmpType = root.getAttribute('data-cmp-type');
      var showCompare = root.getAttribute('data-show-compare') === 'true';
      var showPer = root.getAttribute('data-show-per') === 'true';
      var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
      var compare = parseInt(root.getAttribute('data-compare'), 10) || unit;
      var defaultId = root.getAttribute('data-default-id') || '';
      var map = {};
      try { map = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) {}

      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-bqb-opt]'));
      var myForm = root.querySelector('.bqb__form');
      var myBtn = root.querySelector('[data-bqb-add]');
      var idInput = root.querySelector('[data-bqb-idinput]');
      var qtyInput = root.querySelector('[data-bqb-qtyinput]');
      var chosenQty = 1;

      // Le vrai bouton d'achat de la page (bloc balnia-buy), hors de notre bloc.
      function findMainForm() {
        var forms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < forms.length; i++) { if (!root.contains(forms[i])) return forms[i]; }
        return null;
      }
      var mainForm = findMainForm();
      var mainBtn = document.querySelector('[data-bp-atc]');
      if (mainBtn && root.contains(mainBtn)) mainBtn = null;
      if (!mainBtn && mainForm) {
        mainBtn = mainForm.querySelector('button[name="add"], [type="submit"][name="add"], [type="submit"]');
      }

      // Variante active : input [name="id"] présent sur la page (hors bloc), sinon défaut.
      function currentId() {
        var inputs = document.querySelectorAll('[name="id"]');
        for (var i = 0; i < inputs.length; i++) {
          if (!root.contains(inputs[i]) && inputs[i].value) return inputs[i].value;
        }
        return defaultId;
      }
      function syncVariant() {
        var id = currentId();
        if (id && map[id]) { unit = map[id].p; compare = map[id].c; }
        if (idInput && id) idInput.value = id;
        recalc();
      }

      function recalc() {
        for (var k = 0; k < opts.length; k++) {
          var el = opts[k];
          var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
          var pct = parseFloat(el.getAttribute('data-pct')) || 0;
          var fixed = parseInt(el.getAttribute('data-fixed'), 10) || 0;
          var off = discType === 'fixed' ? fixed : Math.round(unit * pct / 100);
          var after = unit - off; if (after < 0) after = 0;
          var total = after * qty;
          var cmpUnit = (cmpType === 'original' && compare > unit) ? compare : unit;
          var cmpTotal = cmpUnit * qty;
          var savings = cmpTotal - total; if (savings < 0) savings = 0;
          var pctnum = cmpTotal > 0 ? Math.round(savings * 100 / cmpTotal) : 0;

          var totalEl = el.querySelector('[data-bqb-total]');
          if (totalEl) totalEl.innerHTML = money(total);
          var cmpEl = el.querySelector('[data-bqb-compare]');
          if (cmpEl) {
            if (showCompare && savings > 0) { cmpEl.innerHTML = money(cmpTotal); cmpEl.removeAttribute('hidden'); }
            else { cmpEl.setAttribute('hidden', ''); }
          }
          var perEl = el.querySelector('[data-bqb-per]');
          if (perEl && showPer) perEl.innerHTML = money(after) + ' ' + perSuffix;
          var saveEl = el.querySelector('[data-bqb-save]');
          if (saveEl) {
            var tpl = saveEl.getAttribute('data-tpl') || '';
            saveEl.innerHTML = tpl.replace('[%]', pctnum + '%').replace('[$]', money(savings));
          }
        }
      }

      function select(el) {
        for (var k = 0; k < opts.length; k++) {
          opts[k].classList.remove('is-active');
          opts[k].setAttribute('aria-pressed', 'false');
        }
        el.classList.add('is-active');
        el.setAttribute('aria-pressed', 'true');
        chosenQty = parseInt(el.getAttribute('data-qty'), 10) || 1;
        if (qtyInput) qtyInput.value = chosenQty;
      }

      for (var k = 0; k < opts.length; k++) {
        (function (el) { el.addEventListener('click', function () { select(el); }); })(opts[k]);
      }
      var pre = root.querySelector('[data-bqb-opt].is-active') || opts[0];
      if (pre) select(pre);

      function flash(btn) {
        var added = btn.getAttribute('data-added');
        if (!added) return;
        var lbl = btn.querySelector('[data-bqb-label]') || btn;
        var base = btn.getAttribute('data-label') || lbl.textContent;
        lbl.textContent = added;
        setTimeout(function () { lbl.textContent = base; }, 1600);
      }

      // Ajout au panier : on écrit la quantité et on relaie le vrai bouton
      // d'achat (drawer du thème). Sans bouton principal : soumission native
      // de notre form vers /cart/add.
      if (myForm) {
        myForm.addEventListener('submit', function (e) {
          if (myBtn && myBtn.disabled) { e.preventDefault(); return; }
          var id = currentId();
          if (idInput && id) idInput.value = id;
          if (qtyInput) qtyInput.value = chosenQty;
          // On ne relaie le bouton du theme que s'il est reellement cliquable.
          // Desactive, un clic dessus ne fait rien : dans ce cas on laisse
          // notre propre formulaire partir, avec la bonne variante.
          var relayable = mainForm && mainBtn && !mainBtn.disabled &&
                          mainBtn.getAttribute('aria-disabled') !== 'true';
          if (relayable) {
            e.preventDefault();
            var mq = mainForm.querySelector('[name="quantity"]');
            if (mq) {
              mq.value = chosenQty;
              mq.dispatchEvent(new Event('input', { bubbles: true }));
              mq.dispatchEvent(new Event('change', { bubbles: true }));
            }
            mainBtn.click();
            if (myBtn) flash(myBtn);
          }
          // sinon : le form se soumet nativement (POST /cart/add) avec id + quantity.
        });
      }

      // Le prix suit la variante choisie ailleurs sur la page.
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.bp__val')) setTimeout(syncVariant, 40);
      });
      document.addEventListener('change', debounce(syncVariant, 60));

      // L'etat epuise se lit sur LA variante choisie, pas sur le bouton du
      // theme. Le recopier revenait a bloquer tout le produit des qu'une
      // seule taille etait epuisee, alors que les autres restaient en stock.
      var SOLD_TEXT = 'Épuisé';
      var PROD_AVAILABLE = root.getAttribute('data-prod-available') === 'true';
      function variantAvailable() {
        var id = currentId();
        if (id && map[id] && typeof map[id].a === 'boolean') return map[id].a;
        return PROD_AVAILABLE;
      }
      function syncDisabled() {
        if (!myBtn) return;
        var ok = variantAvailable();
        myBtn.disabled = !ok;
        var lbl = myBtn.querySelector('[data-bqb-label]');
        if (lbl) lbl.textContent = ok ? (myBtn.getAttribute('data-label') || lbl.textContent) : SOLD_TEXT;
      }
      syncDisabled();
      document.addEventListener('change', debounce(syncDisabled, 60));
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.bp__val')) setTimeout(syncDisabled, 40);
      });

      syncVariant();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-bqb-root]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["balnia-stories"] && !Shopify.designMode) return;
  try {
    (function () {
  function player(root) { return root.querySelector('[data-pstories-player]'); }
  function setLabel(btn, txt) { var l = btn.querySelector('[data-pstories-add-label]'); if (l) { l.textContent = txt; } else { btn.textContent = txt; } }

  function showCards(root) {
    var st = root._pst; if (!st || !st.groups) return;
    st.groups.forEach(function (g, i) {
      if (i === st.index) {
        g.hidden = false;
        g.scrollLeft = 0;
        g.style.animation = 'none';
        void g.offsetWidth;
        g.style.animation = '';
        Array.prototype.slice.call(g.querySelectorAll('[data-pstories-add]')).forEach(function (btn) {
          btn.disabled = false;
          setLabel(btn, btn.getAttribute('data-default') || 'Ajouter au panier');
        });
      } else {
        g.hidden = true;
      }
    });
    var dlg = player(root);
    var active = st.groups[st.index];
    var multi = active && active.classList.contains('has-multiple');
    Array.prototype.slice.call(dlg.querySelectorAll('[data-pstories-cardnav]')).forEach(function (b) { b.hidden = !multi; });
  }

  function setBars(root) {
    var st = root._pst; if (!st || !st.bars) return;
    st.bars.forEach(function (bar, i) {
      var fill = bar.firstElementChild; if (!fill) return;
      fill.style.transform = 'scaleX(' + (i < st.index ? 1 : 0) + ')';
    });
  }

  function show(root) {
    var st = root._pst; if (!st) return;
    var dlg = player(root);
    var b = st.bubbles[st.index];
    var video = dlg.querySelector('[data-pstories-video]');
    video.pause();
    video.setAttribute('src', b.getAttribute('data-video') || '');
    video.currentTime = 0;
    video.play().catch(function () {});
    var t = dlg.querySelector('[data-pstories-ptitle]');
    if (t) t.textContent = b.getAttribute('data-title') || '';
    var av = dlg.querySelector('[data-pstories-avatar]');
    if (av) { var a = b.getAttribute('data-avatar'); if (a) { av.src = a; av.style.display = ''; } else { av.style.display = 'none'; } }
    setBars(root);
    showCards(root);
  }

  function step(root, dir) {
    var st = root._pst; if (!st) return;
    st.index = (st.index + dir + st.bubbles.length) % st.bubbles.length;
    show(root);
  }

  function bind(root) {
    var dlg = player(root);
    if (!dlg || dlg._pstBound) return;
    dlg._pstBound = true;
    var video = dlg.querySelector('[data-pstories-video]');
    dlg.addEventListener('close', function () { video.pause(); video.removeAttribute('src'); video.load(); });
    video.addEventListener('ended', function () { step(root, 1); });
    video.addEventListener('click', function () { if (video.paused) { video.play().catch(function () {}); } else { video.pause(); } });
    video.addEventListener('timeupdate', function () {
      var st = root._pst; if (!st || !st.bars || !video.duration) return;
      var bar = st.bars[st.index]; if (!bar) return;
      var fill = bar.firstElementChild; if (!fill) return;
      fill.style.transform = 'scaleX(' + Math.min(video.currentTime / video.duration, 1) + ')';
    });
  }

  function open(root, index) {
    var dlg = player(root); if (!dlg) return;
    root._pst = {
      bubbles: Array.prototype.slice.call(root.querySelectorAll('[data-pstories-open]')),
      bars: Array.prototype.slice.call(dlg.querySelectorAll('[data-pstories-bar]')),
      groups: Array.prototype.slice.call(dlg.querySelectorAll('[data-pstories-cards]')),
      index: index
    };
    bind(root);
    if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    show(root);
  }

  document.addEventListener('click', function (e) {
    var bubble = e.target.closest('[data-pstories-open]');
    if (bubble) {
      var root = bubble.closest('[data-pstories]');
      var bubbles = Array.prototype.slice.call(root.querySelectorAll('[data-pstories-open]'));
      open(root, bubbles.indexOf(bubble));
      return;
    }
    var nav = e.target.closest('[data-pstories-nav]');
    if (nav) { step(nav.closest('[data-pstories]'), parseInt(nav.getAttribute('data-pstories-nav'), 10)); return; }
    var close = e.target.closest('[data-pstories-close]');
    if (close) { var d = close.closest('dialog'); if (d) d.close(); return; }
    var cnav = e.target.closest('[data-pstories-cardnav]');
    if (cnav) {
      var croot = cnav.closest('[data-pstories]');
      var cst = croot._pst; if (!cst) return;
      var cg = cst.groups[cst.index]; if (!cg) return;
      var ccard = cg.querySelector('.pstories__card');
      var cw = ccard ? (ccard.offsetWidth + 10) : cg.clientWidth;
      cg.scrollBy({ left: parseInt(cnav.getAttribute('data-pstories-cardnav'), 10) * cw, behavior: 'smooth' });
      return;
    }
    var add = e.target.closest('[data-pstories-add]');
    if (add) {
      var id = add.getAttribute('data-variant'); if (!id) return;
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) { throw new Error('add'); }
        return r.json();
      }).then(function () {
        setLabel(add, add.getAttribute('data-added') || 'Ajouté ✓');
        document.dispatchEvent(new CustomEvent('pstories:added', { bubbles: true }));
        if (add.getAttribute('data-after') === 'cart') { window.location.href = '/cart'; }
      }).catch(function () {
        add.disabled = false;
        setLabel(add, 'Réessayer');
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
